const WORKSPACE_TOOL_IDS = {
  'market-profile': 'market_profile',
  orderflow: 'orderflow',
  'orderflow-preview': 'orderflow_preview',
  'line-chart': 'line_charts',
  'candle-line-chart': 'smart_candlesticks',
  'bar-chart': 'bar_charts',
  'stock-chart': 'stock_chart',
  'payoff-chart': 'payoff_chart',
  'greek-chart': 'greeks_chart',
  'options-table': 'options_table',
  'position-table': 'position_table',
  'index-table': 'indices_table',
  'fii-data': 'fii_data',
  bookmarks: 'mp_bookmarks',
  'global-bookmarks': 'global_bookmarks',
  'hv-stock-chart': 'historical_volatility',
};

const SLUG_TOOL_IDS = [
  { test: /strike_spectrum|spectrum/i, id: 'strike_spectrum' },
  { test: /ntm_oi_change|ntm_oi/i, id: 'ntm_oi_change' },
  { test: /oi_change/i, id: 'oi_change' },
  { test: /ntm_volx/i, id: 'ntm_volx' },
  { test: /ntm_vol/i, id: 'ntm_volume' },
  { test: /vol_charts|volume/i, id: 'volume' },
  { test: /mviz/i, id: 'futures_mviz' },
  { test: /snakes/i, id: 'snakes' },
  { test: /gamma_density/i, id: 'gamma_density' },
  { test: /gamma_curves/i, id: 'gamma_curves' },
  { test: /strike_value/i, id: 'gamma' },
  { test: /strike_wcash/i, id: 'wcash' },
  { test: /strike_oi/i, id: 'oiviz' },
  { test: /strike_iv/i, id: 'iv_curve' },
];

function splitRoute(routeOrPath) {
  try {
    const url = new URL(routeOrPath || '/', 'https://charts.vtrender.com');
    return { pathname: url.pathname, search: url.search };
  } catch {
    return { pathname: routeOrPath || '/', search: '' };
  }
}

export function resolveToolId(routeOrPath) {
  const { pathname, search } = splitRoute(routeOrPath);
  const params = new URLSearchParams(search);
  const normalizedPath = pathname.replace(/\/+$/, '') || '/';
  const parts = normalizedPath.split('/').filter(Boolean);

  if (parts.length === 0) {
    return 'home';
  }

  const [prefix, slug] = parts;

  if (params.get('mode') === 'replay') {
    if (prefix === 'orderflow' || prefix === 'orderflow-preview') {
      return 'orderflow_replay';
    }
    return `${WORKSPACE_TOOL_IDS[prefix] || prefix.replace(/-/g, '_')}_replay`;
  }

  if (prefix.endsWith('_iv-range') || prefix.endsWith('-iv-range')) {
    return 'iv_range';
  }

  if (slug) {
    for (const rule of SLUG_TOOL_IDS) {
      if (rule.test.test(slug)) {
        return rule.id;
      }
    }
    const parentId = WORKSPACE_TOOL_IDS[prefix];
    if (parentId) {
      return `${parentId}_${slug.toLowerCase().replace(/-/g, '_')}`;
    }
    return slug.toLowerCase().replace(/-/g, '_');
  }

  return WORKSPACE_TOOL_IDS[prefix] || prefix.replace(/-/g, '_');
}
